import{a as t}from"./chunk-SGAFZVQH.js";import{a as n}from"./chunk-WIMGWYZL.js";function d(...e){return n(r,e,t(a))}var r=([e])=>e,a=()=>o,o=e=>({hasNext:!0,next:e,done:!0});export{d as a};
